import { ReactElement } from 'react'
import { YourbowInline as YourbowInlineAtom } from '~/components/atoms'
import { RichTextContent } from '~/types/content'

export const Yourbow = (props: RichTextContent): ReactElement => {
	return <YourbowInlineAtom adNumber={props.data.yourbowInlineAdNumber} />
}
